import React, { HTMLAttributes } from "react";
import cn from "classnames";

export type DropdownHeaderProps = HTMLAttributes<HTMLSpanElement>;

export const DropdownHeader = (props: DropdownHeaderProps) => {
  const { className, ...rest } = props;

  return <span className={cn("dropdown-header", className)} {...rest} />;
};

export default DropdownHeader;
